// extracted by mini-css-extract-plugin
export default {"password":"index_password_izmwW clearfix","label":"index_label_t-USQ","input":"index_input_Pa9-Z","loginregi":"index_loginregi_SDqmL","error":"index_error_K2NhO"};